import React, { FC } from 'react';
import { Task, useApprovalDeskPermissions } from '@css-xp/apd-common';
import { useTaskManager } from '../../hooks';

interface RequestProps {
  task: Task;
  text?: string | null;
  refetch?: () => void;
  refetchAll?: () => void;
}

export const TaskDetailAction: FC<RequestProps> = ({
  task,
  refetch,
  refetchAll,
  text = task.taskNumber,
}: RequestProps) => {
  const { openTask } = useTaskManager();
  const { hasRequestDetailAccess } = useApprovalDeskPermissions();

  if (!hasRequestDetailAccess) {
    return (
      <div className="text-overflow" data-testid="task-number-text">
        {text}
      </div>
    );
  }

  return (
    <a
      href="#"
      data-testid="task-number-link"
      onClick={(e) => {
        e.preventDefault();
        openTask({ taskId: task.taskId, refetchAll, refetch, status: task?.approvalStatus });
      }}
    >
      <div className="text-overflow approval-task-detail-action" data-testid="task-number-text">
        {text}
      </div>
    </a>
  );
};
